import React from 'react'
import { motion } from 'framer-motion'

import { FrontEndSkillsData } from './Data/FrontEndSkills.tsx'
import { BackEndSkillsData } from './Data/BackEndSkills.tsx'
import { DatabaseSkillsData } from './Data/DatabaseSkills.tsx'
import { AndroidSkillsData } from './Data/AndroidSkills.tsx'
import { ToolsData } from './Data/Tools.tsx'

import { pageVariants, pageTransition } from './FramerAnimation.ts'
import styles from './skills.module.scss'

const Skills = () => {
  return (
    <div className={styles.skills}>
      <motion.div
        initial="init"
        animate="anim"
        exit="last"
        variants={pageVariants}
        transition={pageTransition}
      >
        <div className={styles.wrapper}>
          <h3 className={styles.skillsopen}>Front End</h3>
          <div className={styles.skills_content}>
            {FrontEndSkillsData.map((item) => (
              <a
                key={item.name}
                href={item.link}
                target="_blank"
                rel="noreferrer"
              >
                {item.icon}
              </a>
            ))}
          </div>
          <h3 className={styles.skillsopen}>Back End</h3>
          <div className={styles.skills_content}>
            {BackEndSkillsData.map((item) => (
              <a
                key={item.name}
                href={item.link}
                target="_blank"
                rel="noreferrer"
              >
                {item.icon}
              </a>
            ))}
          </div>
          <h3 className={styles.skillsopen}>Database</h3>
          <div className={styles.skills_content}>
            {DatabaseSkillsData.map((item) => (
              <a
                key={item.name}
                href={item.link}
                target="_blank"
                rel="noreferrer"
              >
                {item.icon}
              </a>
            ))}
          </div>
          <h3 className={styles.skillsopen}>Android</h3>
          <div className={styles.skills_content}>
            {AndroidSkillsData.map((item) => (
              <a
                key={item.name}
                href={item.link}
                target="_blank"
                rel="noreferrer"
              >
                {item.icon}
              </a>
            ))}
          </div>
          <h3 className={styles.skillsopen}>Tools</h3>
          <div className={styles.skills_content}>
            {ToolsData.map((item) => (
              <a
                key={item.name}
                href={item.link}
                target="_blank"
                rel="noreferrer"
              >
                {item.icon}
              </a>
            ))}
          </div>
        </div>
      </motion.div>
    </div>
  )
}

export default Skills
